import React from "react";
import {Pager} from "../../base/Pager/Pager.jsx";
import {ListView} from "../../base/ListView/ListView.jsx";

export const PagedListView = ({ref, data, itemRender, onPageInfoChange}) => {

    const handlePageInfoChanged = async (pageInfo) => {
        const mappedPageInfo = {
            pageIndex: pageInfo?.skip ? (pageInfo.skip / pageInfo.take) : 0,
            pageSize: pageInfo?.take ?? 20,

        }

        await onPageInfoChange(mappedPageInfo);
    };

    return (
        <>
            <Pager onChange={handlePageInfoChanged} total={data?.totalItemCount ?? 0} ref={ref}/>
            <ListView data={data?.items} item={itemRender} />
        </>
    )
}